import React, { FC } from "react";
import { Classes } from "jss";
import { FiGithub, FiExternalLink } from "react-icons/fi";
import cx from "classnames";

import { Text, Link, Card, Button } from '../../components';
import { projects } from './projects.json';

interface IPortfolioProps {
  classes: Classes<"root" | "projectImg" | "halfHeight" | "container" | "header" | "external" | "tooltip" | "cardsContainer" | "projectCard">;
}

interface IProject {
  title: string;
  demoUrl: string;
  sourceUrl?: string;
  tags: string[];
  imgSrc: string;
  description: string[];
}

export const Portfolio: FC<IPortfolioProps> = ({ classes = {} }) => {
  return (
    <main className={classes.root}>
      <header className={classes.header}>
        <Link className={classes.external} to="https://github.com/jakeswork" icon={<FiGithub />} />
      </header>
      <section className={cx([classes.container, classes.halfHeight])}>
        <Text h1>Hi, I'm Jake <span role="img" aria-label="waving hand">👋</span></Text>
        <Text h3>I'm a software engineer specialised in building full stack enterprise solutions</Text>
        <br />
        <Text h3>You can find some things I've created in my free time below <span role="img" aria-label="pointing down">👇</span></Text>
      </section>
      <section className={cx([classes.container, classes.cardsContainer])}>
        {
          projects.map((project: IProject) => (
            <Card className={classes.projectCard} key={project.title}>
              <div>
                <img className={classes.projectImg} src={`images/${project.imgSrc}`} alt="Project screenshot" />
                <Text h2>{project.title}</Text>
                {project.description.map((paragraph, i) => <Text key={`paragraph-${i}`}>{paragraph}</Text>)}
              </div>
              <div>
                <Link style={{ width: '100%', marginTop: 8 }} to={project.demoUrl}>
                  <Button secondary fullWidth icon={<FiExternalLink />}>
                    Visit
                  </Button>
                </Link>
              </div>
            </Card>
          ))
        }
      </section>
    </main>
  );
}
